import { Directive, ElementRef, Input, HostListener, Inject, OnInit, DoCheck } from '@angular/core';

@Directive({
    selector: '[sticky]'
})
export class StickyDirective implements OnInit, DoCheck {
    @Input('sticky') sticky;

    private mainArea: HTMLElement
    private footer: HTMLElement
    private bodyHeight: number = 0

    private isMobile: boolean = false

    get scrollYPos(): number {
        return (window.pageYOffset || document.documentElement.scrollTop)
    }

    get offsetTop(): number {
        const windowTop = this.mainArea.getBoundingClientRect().top
        return windowTop + this.scrollYPos
    }

    get offsetBottom(): number {
        const windowBottom = this.footer && this.footer.getBoundingClientRect().top || 0
        return windowBottom + this.scrollYPos
    }

    get mainAreaBottom(): number {
        return this.mainArea.offsetHeight
    }

    get elementTop(): number {
        return this.element.nativeElement.getBoundingClientRect().top
    }

    get elementBottom(): number {
        return this.offsetTop + this.element.nativeElement.offsetHeight
    }

    constructor(
        private element: ElementRef
    ) { }

    ngOnInit() {
        this.mainArea = (<any>document.querySelector('.main-area'))
        this.footer = (<any>document.querySelector('.footer'))
        this.attachMediaQueryHandler()
    }

    ngDoCheck() {
        if (!this.hasBodyHeightChanged()) { return }

        this.setElementPosition()
    }

    @HostListener('window:scroll') onScroll() {
        this.setElementPosition()
    }

    private setElementPosition() {

        if (this.isMobile || this.flowContainerIsSmallerThanElement()) { return }

        let positionY;

        if (this.scrollYPos <= this.offsetTop) { // above top
            positionY = 0
        }

        const scrollTopOffset = 10
        if ((this.scrollYPos + scrollTopOffset) > this.offsetTop && this.elementBottom < this.offsetBottom) { // scroll area
            positionY = (this.scrollYPos - this.offsetTop) + scrollTopOffset
        }

        if ((this.elementBottom + positionY) >= this.offsetBottom) { // below footer
            positionY = (this.mainAreaBottom - this.element.nativeElement.offsetHeight)
        }

        this.element.nativeElement.style.marginTop = `${(positionY)}px`
    }

    private hasBodyHeightChanged() {
        if (this.bodyHeight === document.body.clientHeight) { return false }

        this.bodyHeight = document.body.clientHeight
        return true
    }

    private flowContainerIsSmallerThanElement() {
        const flowContainer: any = document.querySelector('.flow-container')

        if (flowContainer && flowContainer.offsetHeight < this.element.nativeElement.offsetHeight) { return true }

        return false
    }

    private attachMediaQueryHandler() {
        if (window.matchMedia) {
            const mq: MediaQueryList = window.matchMedia('(min-width: 64.063em)')
            mq.addListener(this.disableScroll.bind(this))
            this.disableScroll(mq);
        }
    }

    private disableScroll(mq: MediaQueryList) {
        const el = this.element.nativeElement

        if (!mq.matches) {
            this.isMobile = true
            el.style.marginTop = null
        } else if (this.isMobile) {
            this.isMobile = false
            this.setElementPosition()
        }
    }
}
